import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  ACTOR_TYPES,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  UserManagementInformation,
} from '@savgroup-front-common/types';

const ENTITY_TYPE = ':entityType';

const ENDPOINT = `${APIConfiguration.authorization}users/management/${ENTITY_TYPE}`;

export interface ListManagementUsersQueryPayload {
  entityType: ACTOR_TYPES;
}

export const listManagementUsersRequest = ({
  entityType,
}: ListManagementUsersQueryPayload): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(ENTITY_TYPE, entityType),
  config: { method: SUPPORTED_METHODS.GET },
});

const listManagementUsersQuery = async (
  payload: ListManagementUsersQueryPayload,
): Promise<BackResponse<UserManagementInformation[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<UserManagementInformation[]>>(
      listManagementUsersRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default listManagementUsersQuery;
